import { useEditor } from "@craftjs/core";

// review-1008-Frontend-6716 (T3.14 follow-up): a media block's `isLoading`
// prop is only ever meaningful in the BUILDER, where an upload started in
// this tab can still finish. FE#6716 stops new saves from persisting a stuck
// `isLoading:true` (segmentPayloadHygiene.js stripBlobMediaSrcs), but blocks
// saved BEFORE that fix still carry it. MEASURED live on web-stg.iyuga.net
// (main.97829898.js): a wheel saved mid-upload by the pre-6716 bundle
// (main.6d50d3d4.js) still shows an endless "Loading video" spinner to every
// visitor on /wheel/<id>, because nothing on the read-only view ever saves.
//
// The read-only views (ViewWheel, MobileView, Segment page) mount the canvas
// in `<Editor enabled={false}>`; no upload can be in flight there, so a
// persisted `isLoading` is always stale. Show the upload skeleton only when
// the editor is not explicitly read-only; the block then falls through to its
// normal media/empty state.
export default function useUploadSkeletonVisible(isLoading) {
  const { enabled } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));
  return Boolean(isLoading) && enabled !== false;
}
